import { Flex, Box } from '..';

export function ProgressIndicator({
  currentStepIndex,
  numberOfSteps,
  ...props
}: {
  numberOfSteps: number;
  currentStepIndex: number;
}) {
  if (numberOfSteps <= 1) {
    return null;
  }
  const arr = Array.from(Array(numberOfSteps).keys());
  return (
    <Flex
      justifyContent="center"
      aria-label={`Step ${currentStepIndex + 1} of ${numberOfSteps}`}
      {...props}
    >
      {arr.map(i => {
        const isPassed = currentStepIndex >= i;
        return (
          <Box
            key={i}
            size={{ _: '8px', lg: '10px' }}
            bg={isPassed ? 'primaryIcon' : 'neutral.4'}
            borderRadius={1000}
            m={1}
          />
        );
      })}
    </Flex>
  );
}
